import { SkeletonDesignTokens } from '@primeng/themes/types/skeleton';

export default {
    root: {
        borderRadius: '{content.border.radius}'
    },
    colorScheme: {
        light: {
            root: {
                background: '{surface.100}', //changed by mazars
                animationBackground: 'rgba(255,255,255,0.4)'
            }
        },
        dark: {
            root: {
                background: 'rgba(255, 255, 255, 0.06)',
                animationBackground: 'rgba(255, 255, 255, 0.04)'
            }
        }
    }
} as SkeletonDesignTokens;
